module.exports = __webpack_public_path__ + "img/transform_compatible.6a3231c3.svg";